import { z } from "zod";
export const Problem = z
    .object({
    // RFC 7807 §3.1: `type` is a URI *reference* (RFC 3986) — relative refs
    // are permitted. The api's domain handlers use stable relative types like
    // `/errors/checkout.pending_exists` that clients switch on, so this must
    // NOT be `z.url()` (which rejects relative refs and forced everything to
    // the `about:blank` default — silently breaking type-gated client logic).
    type: z.string().default("about:blank"),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    errors: z.record(z.string(), z.array(z.string())).optional(),
})
    // RFC 7807 §3.2 permits problem objects to carry extension members beyond
    // the standard fields. Domain handlers attach actionable context to the
    // thrown body (e.g. `existingOrderId` on the checkout single-active-pending
    // 409, `variantId` on a soft-deleted-line 410). `.passthrough()` keeps those
    // members through `Problem.parse` so clients can act on them instead of
    // having them silently stripped.
    .passthrough();
